<div (click)="onCancel()" class="settings-overlay">
  <div (click)="$event.stopPropagation()" class="settings-dialog">
    <h2 class="settings-title">{{ "Presentation settings" | translate }}</h2>

    <form [formGroup]="settingsForm" class="settings-form">
      <div class="form-group">
        <label class="form-label">{{ "Playback speed" | translate }}</label>
        <select class="form-control" formControlName="playbackSpeed">
          <option *ngFor="let option of playbackSpeedOptions" [value]="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label class="form-label">{{ "Animation speed" | translate }}</label>
        <select class="form-control" formControlName="animationSpeed">
          <option *ngFor="let option of animationSpeedOptions" [value]="option.value">
            {{ option.label | translate }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label class="form-label">{{ "Animation type" | translate }}</label>
        <select class="form-control" formControlName="animationType">
          <option *ngFor="let option of animationTypeOptions" [value]="option.value">
            {{ option.label | translate }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label class="form-label">{{ "View mode" | translate }}</label>
        <select class="form-control" formControlName="viewMode">
          <option *ngFor="let option of viewModeOptions" [value]="option.value">
            {{ option.label | translate }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label class="form-label">{{ "Auto-hide controls delay" | translate }}</label>
        <input class="form-control" formControlName="autoHideControlsDelay" max="10" min="1" step="0.5" type="number" />
        <small class="form-help">{{ "seconds" | translate }}</small>
      </div>

      <div class="form-group">
        <label class="form-label">
          <input formControlName="blurredBackground" type="checkbox" />
          {{ "Blurred background" | translate }}
        </label>
        <small class="form-help">{{ "Display the current image as a blurred background" | translate }}</small>
      </div>
    </form>

    <div class="dialog-actions">
      <button (click)="onCancel()" class="btn btn-secondary">
        {{ "Cancel" | translate }}
      </button>
      <button (click)="onSave()" class="btn btn-primary">
        {{ "Save" | translate }}
      </button>
    </div>
  </div>
</div>
